import React from 'react';
import { useState } from 'react';
import { InvitationModal } from 'tutorapp-components';
import Studentsetupappointment from '../components/Studentsetupappointment';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { apiService } from '../utils/apiRequest';
import { toast, ToastContainer } from 'react-toastify';
import Lottie from 'lottie-react';
import { resetFamilyPresetValues, setRepeat } from '../redux/actions/familyPresetValuesActions';
import { setSessiontype } from '../redux/actions/familyPresetValuesActions';
import CircularProgress from '@mui/material/CircularProgress';

export default function Studentsetupscreen() {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [sessionType, setSessionType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [appointmentid, setAppointmentid] = useState('');
  const [show, setShow] = useState(false);
  const [showCelebration, setShowCelebration] = useState(false);

  const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const options = ['Daily', 'Weekly', 'Monthly', 'Yearly'];
  const appointmentId = useSelector((state) => state.familyPresetValues.appointmentId);
  const date = useSelector((state) => state.familyPresetValues.date);
  const time = useSelector((state) => state.familyPresetValues.time);
  const subjectId = useSelector((state) => state.familyPresetValues.subjectId);
  const appointmentType = useSelector((state) => state.familyPresetValues.appointmentType);

  const onarrowclick = () => {
    navigate('/editAppointment');
  };

  const icons = {
    backarrow: './images/ic_back.svg',
    address: './images/ic_tutoring_address.svg',
    repeat: './images/ic_repeat.svg',
    sessionappointment: './images/ic_sessionappointment.svg',
    close: './images/ic_close.svg',
    progress: './images/ic_4.svg',
    sessionIcon: './images/Sessions_Per_Week.svg',
    modalclose: './images/ic_close2.svg',
  };

  const handlerepeat = () => {
    setModalVisible(true);
  };

  const handleback = () => {
    navigate('/student-date-time');
  };

  const formatTime = (time) => {
    return time ? `${time}:00` : '';
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

 // Helper function to calculate duration in seconds from time.start and time.end
  const calculateDurationInSeconds = (start, end) => {
    if (!start || !end) return 0;
    
    const [startHours, startMinutes] = start.split(':').map(Number);
    const [endHours, endMinutes] = end.split(':').map(Number);
    
    const startSeconds = startHours * 3600 + startMinutes * 60;
    const endSeconds = endHours * 3600 + endMinutes * 60;
    
    return endSeconds - startSeconds; // Duration in seconds
  };

  // Helper function to calculate repeat_count
  const calculateRepeatCount = () => {
    const remaining_hrs = appointmentId?.remaining_hour || 0;
    const durationSeconds = calculateDurationInSeconds(time?.start, time?.end);
    
    if (durationSeconds <= remaining_hrs) return 0; // Avoid division by zero or invalid duration
    
    const remainingSeconds = remaining_hrs * 3600; // Convert hours to seconds
    const repeat_count = Math.floor(remainingSeconds / durationSeconds); // Integer division
    
    return repeat_count;
  };
  
  const repeat_count = calculateRepeatCount();

  const handleRepeatSelect = (option) => {
    setSelectedOption(option);
    setModalVisible(false);
  };

  const handlecreateappointment = (createdata) => {
    createAppointment(createdata);
    const repeatData = {
      choice: createdata?.repeat?.repeat,
      frequency: createdata?.repeat?.frequency,
      occurrences: createdata?.repeat?.occurrences,
      days: createdata?.repeat?.days,
    };
    dispatch(setSessiontype(createdata.session_type));
    dispatch(setRepeat(repeatData));
  };

  const createAppointment = async (appointmentData) => {
    setLoading(true);
    try {
      const createAppointmentUrl = process.env.REACT_APP_API_URL + 'createAppointment';
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          franchise_id: selectedFranchise.franchise_id,
          enrollment_id: appointmentId.enrollment_id,
          tutor_id: selectedFranchise.tutor_id,
          student_id: [appointmentId.student_id],
          appointment_type: `${appointmentType.appointment_type}`,
          subject_id: subjectId,
          appointment_date: formatDate(date),
          appointment_start_time: formatTime(time.start),
          appointment_end_time: formatTime(time.end),
          session_type: appointmentData.session_type,
          repeat_choice:
            !appointmentData.repeat || !appointmentData.repeat.repeat || appointmentData.repeat.repeat === 'None'
              ? ''
              : appointmentData.repeat.repeat,
          repeat_frequency: appointmentData.repeat?.frequency || '',
          repeat_occurences: appointmentData.repeat?.occurrences || '',
          weeks: appointmentData.repeat?.days || '',
          sessions_per_week: appointmentId?.session_per_week || '',
        }),
      };
      const response = await apiService(createAppointmentUrl, options);
      if (response.status === 'success') {
        dispatch(resetFamilyPresetValues());
        setShowCelebration(true);
        if (selectedFranchise.send_external_cal_invitation === '1') {
          setAppointmentid(response.appointment_id);
          setShow(true);
        } else {
          setTimeout(() => {
            navigate('/MyAppointment');
          }, 1000);
        }
      } else {
        toast.error(response.message, {
          autoClose: false,
          position: 'top-center',
          autoClose: 5000,
          closeOnClick: true,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'dark',
          style: { backgroundColor: '#D32F2F', color: '#fff', fontWeight: '500' },
        });
        console.error('Failed to create appointment:', response.message);
      }
    } catch (error) {
      console.error('Error while creating appointment:', error);
      toast.error(error.message, {
        autoClose: false,
        position: 'top-center',
        autoClose: 5000,
        closeOnClick: true,
        hideProgressBar: true,
        pauseOnHover: true,
        draggable: true,
        theme: 'dark',
        style: { backgroundColor: '#D32F2F', color: '#fff', fontWeight: '500' },
      });
    } finally {
      setLoading(false);
    }
  };

  const sendinvitation = async (appointmentid) => {
    setLoading(true);
    try {
      const endpoint = process.env.REACT_APP_API_URL + 'getCalendarEmail';
      const options = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ appointment_id: appointmentid }),
      };

      const response = await apiService(endpoint, options);
      if (response.status === 'success') {
        navigate('/MyAppointment');
      } else {
        toast.error(response.message || 'Failed to fetch student names', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'dark',
          style: { backgroundColor: '#D32F2F', color: '#fff', fontWeight: '500' },
        });
      }
    } catch (error) {
      console.error('Error fetching student names:', error);
      toast.error('An error occurred while fetching student names', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: 'dark',
        style: { backgroundColor: '#D32F2F', color: '#fff', fontWeight: '500' },
      });
    } finally {
      setLoading(false);
    }
  };

  const handlehide = () => {
    setShow(false);
  };

  const onsend = () => {
    sendinvitation(appointmentid);
    setShow(false);
  };

  const oncancel = () => {
    setShow(false);
    navigate('/MyAppointment');
  };

  const handleselectionclose = () => {
    navigate('/MyAppointment');
  };

  const isCreateDisabled = !sessionType;

  return (
    <div>
      {/* MUI CircularProgress Loader */}
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          <CircularProgress
            size={48}
            sx={{ color: 'black' }}
            aria-label="Loading"
          />
        </div>
      )}

      <Studentsetupappointment
        onarrowclick={onarrowclick}
        icons={icons}
        handlerepeat={handlerepeat}
        options={options}
        handleback={handleback}
        handlecreateappointment={handlecreateappointment}
        onRepeatSelect={handleRepeatSelect}
        isCreateDisabled={isCreateDisabled}
        selectedOption={selectedOption}
        sessionType={sessionType}
        tutoraddress={appointmentId?.tutor_address ?? 'Address not available'}
        allocation={appointmentId?.allocation}
        sessionperweek={appointmentId?.session_per_week}
        handleselectionclose={handleselectionclose}
        repeat_count={repeat_count}
        repeatappointmentlimit={parseInt(selectedFranchise?.repeat_appointment_limit)}
        displayRepeat={appointmentId?.display_repeat == 1 && selectedFranchise?.allow_repeat_session_report == 1}
      />

      <InvitationModal isVisible={show} onClose={handlehide} onsend={onsend} oncancel={oncancel} />
      {showCelebration && (
        <>
          <Lottie
            animationData={require('../assets/celebration.json')}
            style={{
              position: 'absolute',
              width: 300,
              height: 300,
              top: '50%',
              left: 0,
              transform: 'translateY(-50%)',
            }}
          />
          <Lottie
            animationData={require('../assets/celebration.json')}
            style={{
              position: 'absolute',
              width: 300,
              height: 300,
              top: '50%',
              right: 0,
              transform: 'translateY(-50%)',
            }}
          />
        </>
      )}
      <ToastContainer />
    </div>
  );
}